import api from './axios';

export const listSalesmen = () => api.get('/salesmen').then((r) => r.data);

// Server-side search + pagination — see listCustomersPage for why this can't be a
// client-side filter over a fetched page.
export const listSalesmenPage = ({ page = 1, limit = 50, search = '' } = {}) =>
  api.get('/salesmen', { params: { page, limit, search } }).then((r) => ({
    items: r.data,
    total: Number(r.headers['x-total-count'] ?? r.data.length),
  }));
export const createSalesman = (data) => api.post('/salesmen', data).then((r) => r.data);
export const updateSalesman = (id, data) => api.put(`/salesmen/${id}`, data).then((r) => r.data);
export const deleteSalesman = (id) => api.delete(`/salesmen/${id}`).then((r) => r.data);
export const bulkUploadSalesmen = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/salesmen/bulk-upload', formData).then((r) => r.data);
};
